import { MyUploadsTable } from '@/routes/_auth/_modules/_app/my-uploads/-components/MyUploadsTable'
import { myUploadsSearchSchema } from '@/hooks/queries/uploads/useUploadToS3'
import { CREDIT_CSV_UPLOAD_TYPES } from '@repo/csv'
import { createFileRoute } from '@tanstack/react-router'

const CREDIT_MY_UPLOAD_TYPES = [...CREDIT_CSV_UPLOAD_TYPES] as const

export const Route = createFileRoute('/_auth/_modules/credit/my-uploads/')({
  component: MyUploadsPage,
  validateSearch: (search) => myUploadsSearchSchema.parse(search),
})

function MyUploadsPage() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  return (
    <MyUploadsTable
      module="credit"
      uploadTypes={CREDIT_MY_UPLOAD_TYPES}
      allUploadsPermission="credit_upload_allUploads_view"
      search={search}
      navigate={navigate}
      onOpenUpload={(scope, fileName) =>
        navigate({ to: '/credit/my-uploads/$scope/$fileName', params: { scope, fileName } })
      }
    />
  )
}
